/** ERP feature codes � must match backend `features.code` */
export const FEATURE = {
  POS_BILLING: 'POS_BILLING',
  POS_SHIFT_MANAGEMENT: 'POS_SHIFT_MANAGEMENT',
  POS_SPLIT_PAYMENT: 'POS_SPLIT_PAYMENT',
  POS_PROMOTIONS_ENGINE: 'POS_PROMOTIONS_ENGINE',
  POS_RETURNS: 'POS_RETURNS',
  POS_EXCHANGE: 'POS_EXCHANGE',
  POS_ANALYTICS: 'POS_ANALYTICS',
  POS_GIFT_CARDS: 'POS_GIFT_CARDS',
  POS_TERMINAL_MANAGEMENT: 'POS_TERMINAL_MANAGEMENT',
  INVENTORY: 'INVENTORY',
  WAREHOUSE: 'WAREHOUSE',
  EMPLOYEE_BASIC: 'EMPLOYEE_BASIC',
  REPORTING: 'REPORTING',
  PROCUREMENT: 'PROCUREMENT',
  PROCUREMENT_BASIC: 'PROCUREMENT_BASIC',
  PROCUREMENT_RFQ: 'PROCUREMENT_RFQ',
  PROCUREMENT_APPROVALS: 'PROCUREMENT_APPROVALS',
  PROCUREMENT_MULTI_WAREHOUSE: 'PROCUREMENT_MULTI_WAREHOUSE',
  PROCUREMENT_ADVANCED_ANALYTICS: 'PROCUREMENT_ADVANCED_ANALYTICS',
  PROCUREMENT_CATALOG: 'PROCUREMENT_CATALOG',
  PROCUREMENT_CONTRACTS: 'PROCUREMENT_CONTRACTS',
  PROCUREMENT_THREE_WAY_MATCH: 'PROCUREMENT_THREE_WAY_MATCH',
  LOYALTY: 'LOYALTY',
  CRM_BASIC: 'CRM_BASIC',
  CRM_PIPELINE: 'CRM_PIPELINE',
  CRM_ANALYTICS: 'CRM_ANALYTICS',
  CRM_AUTOMATION: 'CRM_AUTOMATION',
  CRM_CAMPAIGNS: 'CRM_CAMPAIGNS',
  CRM_WHATSAPP: 'CRM_WHATSAPP',
  CRM_FORECASTING: 'CRM_FORECASTING',
  CRM_CUSTOMER_360: 'CRM_CUSTOMER_360',
  CRM_TERRITORY: 'CRM_TERRITORY',
  CRM_CUSTOMER_PORTAL: 'CRM_CUSTOMER_PORTAL',
  LEAD_GEN_BASIC: 'LEAD_GEN_BASIC',
  LEAD_GEN_LANDING_PAGES: 'LEAD_GEN_LANDING_PAGES',
  LEAD_GEN_SCORING: 'LEAD_GEN_SCORING',
  LEAD_GEN_AUTOMATION: 'LEAD_GEN_AUTOMATION',
  LEAD_GEN_CAMPAIGNS: 'LEAD_GEN_CAMPAIGNS',
  LEAD_GEN_ATTRIBUTION: 'LEAD_GEN_ATTRIBUTION',
  LEAD_GEN_ROUTING: 'LEAD_GEN_ROUTING',
  LEAD_GEN_ABM: 'LEAD_GEN_ABM',
  MARKETING_BASIC: 'MARKETING_BASIC',
  MARKETING_EMAIL: 'MARKETING_EMAIL',
  MARKETING_SMS: 'MARKETING_SMS',
  MARKETING_WHATSAPP: 'MARKETING_WHATSAPP',
  MARKETING_JOURNEY: 'MARKETING_JOURNEY',
  MARKETING_AUTOMATION: 'MARKETING_AUTOMATION',
  MARKETING_AB_TEST: 'MARKETING_AB_TEST',
  MARKETING_ATTRIBUTION: 'MARKETING_ATTRIBUTION',
  MARKETING_ABM: 'MARKETING_ABM',
  MARKETING_PUSH: 'MARKETING_PUSH',
  MARKETING_CALENDAR: 'MARKETING_CALENDAR',
  MARKETING_ADVANCED_ANALYTICS: 'MARKETING_ADVANCED_ANALYTICS',
  HR_BASIC: 'HR_BASIC',
  HR_ATTENDANCE: 'HR_ATTENDANCE',
  HR_PAYROLL: 'HR_PAYROLL',
  HR_APPRAISAL: 'HR_APPRAISAL',
  HR_RECRUITMENT: 'HR_RECRUITMENT',
  HR_CLAIMS: 'HR_CLAIMS',
  HR_ANALYTICS: 'HR_ANALYTICS',
  SOCIAL_BASIC: 'SOCIAL_BASIC',
  SOCIAL_INBOX: 'SOCIAL_INBOX',
  SOCIAL_PUBLISHING: 'SOCIAL_PUBLISHING',
  SOCIAL_CAMPAIGNS: 'SOCIAL_CAMPAIGNS',
  SOCIAL_ANALYTICS: 'SOCIAL_ANALYTICS',
  SOCIAL_AUTOMATION: 'SOCIAL_AUTOMATION',
  SOCIAL_LISTENING: 'SOCIAL_LISTENING',
  SOCIAL_REPUTATION: 'SOCIAL_REPUTATION',
  SOCIAL_COMPETITOR: 'SOCIAL_COMPETITOR',
  SOCIAL_MULTI_BRAND: 'SOCIAL_MULTI_BRAND',
  SOCIAL_CALENDAR: 'SOCIAL_CALENDAR',
  SOCIAL_APPROVALS: 'SOCIAL_APPROVALS',
  WHATSAPP_BUSINESS: 'WHATSAPP_BUSINESS',
  DESK_BASIC: 'DESK_BASIC',
  DESK_SLA: 'DESK_SLA',
  DESK_AUTOMATION: 'DESK_AUTOMATION',
  DESK_LIVE_CHAT: 'DESK_LIVE_CHAT',
  DESK_ANALYTICS: 'DESK_ANALYTICS',
  DESK_PROJECTS: 'DESK_PROJECTS',
  DESK_CUSTOM_FORMS: 'DESK_CUSTOM_FORMS',
  DESK_CUSTOMER_360: 'DESK_CUSTOMER_360',
  DESK_PORTAL: 'DESK_PORTAL',
  DESK_OMNICHANNEL: 'DESK_OMNICHANNEL',
  DESK_CSAT: 'DESK_CSAT',
  DESK_NPS: 'DESK_NPS',
  PAYROLL: 'PAYROLL',
  PROJECTS_BASIC: 'PROJECTS_BASIC',
  PROJECTS_SPRINTS: 'PROJECTS_SPRINTS',
  PROJECTS_GANTT: 'PROJECTS_GANTT',
  PROJECTS_AUTOMATION: 'PROJECTS_AUTOMATION',
  PROJECTS_ADVANCED_ANALYTICS: 'PROJECTS_ADVANCED_ANALYTICS',
  PROJECTS_CLIENT_PORTAL: 'PROJECTS_CLIENT_PORTAL',
  PROJECTS_TIMESHEETS: 'PROJECTS_TIMESHEETS',
  PROJECTS_PORTFOLIO: 'PROJECTS_PORTFOLIO',
  PROJECTS_BILLING: 'PROJECTS_BILLING',
  PROJECTS_RESOURCE: 'PROJECTS_RESOURCE',
  FINANCE_GL: 'FINANCE_GL',
  FINANCE_BASIC: 'FINANCE_BASIC',
  FINANCE_ACCOUNTING: 'FINANCE_ACCOUNTING',
  FINANCE_MULTI_CURRENCY: 'FINANCE_MULTI_CURRENCY',
  FINANCE_ASSETS: 'FINANCE_ASSETS',
  FINANCE_BUDGETING: 'FINANCE_BUDGETING',
  FINANCE_ADVANCED_REPORTS: 'FINANCE_ADVANCED_REPORTS',
  DELIVERY: 'DELIVERY',
  ECOMMERCE: 'ECOMMERCE',
  ANALYTICS: 'ANALYTICS',
} as const;

export type FeatureCode = (typeof FEATURE)[keyof typeof FEATURE];

export const LOCKED_MODULE_FEATURES: FeatureCode[] = [
  FEATURE.HR_BASIC,
  FEATURE.HR_ATTENDANCE,
  FEATURE.HR_PAYROLL,
  FEATURE.HR_APPRAISAL,
  FEATURE.HR_RECRUITMENT,
  FEATURE.HR_CLAIMS,
  FEATURE.HR_ANALYTICS,
  FEATURE.PAYROLL,
  FEATURE.PROJECTS_BASIC,
  FEATURE.PROJECTS_SPRINTS,
  FEATURE.PROJECTS_GANTT,
  FEATURE.PROJECTS_AUTOMATION,
  FEATURE.PROJECTS_ADVANCED_ANALYTICS,
  FEATURE.PROJECTS_CLIENT_PORTAL,
  FEATURE.FINANCE_BASIC,
  FEATURE.FINANCE_ACCOUNTING,
  FEATURE.FINANCE_MULTI_CURRENCY,
  FEATURE.FINANCE_ASSETS,
  FEATURE.FINANCE_BUDGETING,
  FEATURE.FINANCE_ADVANCED_REPORTS,
  FEATURE.DELIVERY,
  FEATURE.ECOMMERCE,
  FEATURE.ANALYTICS,
];
